import { IBrowser, IDevice, IOS, UAParser } from "ua-parser-js";

export enum IUADevice {
	mobile,
	tablet,
	pc,
	other
}

export enum IUABrowser {
	chrome,
	chromeLike,
	safari,
	firefox,
	ie,
	edge,
	other
}

const browserMap: { [ key: string ]: IUABrowser } = {
	"Chrome": IUABrowser.chrome,
	"Chrome Headless": IUABrowser.chromeLike,
	"Chrome WebView": IUABrowser.chromeLike,
	"Chromium": IUABrowser.chromeLike,
	"Edge": IUABrowser.edge,
	"Firefox": IUABrowser.firefox,
	"IE": IUABrowser.ie,
	// "Mozilla": IUABrowser.firefox,
	"Mobile Safari": IUABrowser.safari,
	"Safari": IUABrowser.safari

};

class UserAgentInfo {

	readonly device: IUADevice;

	readonly browser: IUABrowser;

	readonly supportedOSVersion: boolean;

	constructor() {
		const result = new UAParser( window.navigator.userAgent );
		this.device = this.setDevice( result.getDevice() );
		this.browser = this.setBrowser( result.getBrowser() );
		this.supportedOSVersion = this.setSupportState( result.getOS() );
		// alert( JSON.stringify( result.getOS() ) );
	}

	private setSupportState( os: IOS ): boolean {
		try {
			switch ( os.name ) {
				case "Android":
					// Android 6より上なら許可（7以上）
					return Number( os.version!.split( "." )[ 0 ] ) > 6;
				case "iOS":
					// iOS 10より上なら許可（11以上）
					return Number( os.version!.split( "." )[ 0 ] ) > 10;
				case "Mac OS":
					// Mac OS 10.12より上なら許可（13以上）
					return Number( os.version!.split( "." )[ 1 ] ) > 12;
				case "Windows":
					// Winは、基本的にはサポート対象にするけど...
					return true;
				case "Chromium OS": // ChromeBookとか
					// 基本的にはChromeだろうし、OKしておく
					return true;
				// todo 以下は悩みどころたち
				// case "CentOS":
				// 	break;
				// case "Ubuntu":
				// 	break;
				default:
					return false;
			}
		} catch ( e ) {
			console.log( e );
		}

		return false;
	}

	private setDevice( value: IDevice ): IUADevice {
		// console.log( value.type );

		if ( value.type === "tablet" ) {
			return IUADevice.tablet;
		}
		if ( value.type === "mobile" ) {
			return IUADevice.mobile;
		}
		if ( value.type === undefined ) {
			return IUADevice.pc;
		}

		return IUADevice.other;
	}

	private setBrowser( value: IBrowser ): IUABrowser {
		// console.log( value.name );
		if ( value.name === undefined ) {
			return IUABrowser.other;
		}

		const browser = browserMap[ value.name ];

		if ( browser === undefined ) {
			return IUABrowser.other;
		}

		return browser;

	}
}

export const userAgentInfo = new UserAgentInfo();